<template>
  <div class="page-container" id="page-container">
    <div class="page-title padding pb-0 ">
      <h2 class="text-md mb-0">{{ $t('message.Author.header') }}</h2>
    </div>
    <div class="padding">
      <div class="row">
        <div v-if="!authorsLoaded" class="h-100 d-flex justify-content-center align-items-center">
          <img alt="Vue logo" src="@/assets/img/loading.gif" width="100px" height="100px">
        </div>

        <div v-else class="col-md-12">
          <div class="card card-form">
            <div class="card-body">
              <div class="form-section-header">{{ $t('message.Author.header') }}</div>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Author.name') }} </label>
                </b-col>

                <b-col sm="9">
                  <label class="col-form-label">{{ author.name }}</label>
                </b-col>
              </b-row>

              <b-row class="my-3">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Author.description') }} </label>
                </b-col>

                <b-col sm="9" v-html="author.description">
                </b-col>
              </b-row>

              <b-row v-if="false" class="my-3">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Author.books') }}</label>
                </b-col>

                <b-col sm="9">
                  <b-list-group>
                    <b-list-group-item  variant="primary" v-for="book in author.books" :key="book.id" href="#" @click.prevent="$router.push({name: 'BookView', params: {id:book.id }})">{{ book.title }}</b-list-group-item>
                  </b-list-group>
                </b-col>
              </b-row>

              <div class="form-buttons">
                <button type="submit" class="btn btn-success" @click="$router.go(-1)">{{ $t('message.return') }} </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {AUTHOR_REQUEST_BY_ID} from '@/store/actions/authors';

  export default {
    name: "AuthorView",

    data() {
      return {
        author: {
          name: null,
          description: ''
        },
      }
    },

    mounted() {
      this.getAuthor(this.$route.params.id);
    },

    methods: {
      proceed() {
        this.$validator.validateAll().then(result => {
          if (!result) {
            this.$swal({
              title: 'Error!',
              text: this.$t("message.Guideline.fillRequiredFields"),
              type: 'error',
              confirmButtonText: 'OK'
            });

            this.showValidateErrors = true;
          } else {
            if (this.author.id == undefined) {
              return this.saveAuthor();
            }

            return this.updateAuthor();
          }
        });
      },

      async getAuthor(id) {
        if (id != undefined) {
          this.$store.dispatch(AUTHOR_REQUEST_BY_ID, id).then(author => {
            this.author = author;
          }).catch(err => {
            console.log(err);
          })
        }
      }
    },
  }
</script>


<style scoped>

</style>